import { Observable } from 'rxjs/Observable';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { forkJoin, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { GoalData, Goal } from '../../../@core/interfaces/common/CalorieFriend/goals';


@Injectable()
export class GoalFormResolverModule implements Resolve<Observable<any>> {
  constructor(private GoalsService: GoalData) { }

   resolve(route: ActivatedRouteSnapshot) {
     return forkJoin(
       route.params.id ? this.GoalsService.get(route.params.id) : of(this.getEmptyGoal()),
      )
      .pipe(map(([goal]: [Goal]) => {
         return { goal };
       }));
  }

  private getEmptyGoal(): Goal {
    return {
      id: undefined,
      PatientID: undefined,
      goalType: 0,
      goalValue: 0,
      startValue: 0,
      targetDate: new Date(),
      startDate: new Date(),
      createdDate: new Date(),
      achievedDate: new Date(),
      goalName: '',
      progress: 0,
    };
  }

}
